export const glosarioProceso1 = {
    // CONTRATACION: {
    //     id: 'CONTRATACION',
    //     name: 'Inicio Proceso Contratación',
    //     attachments:undefined,
    //     midAge: 0.5,
    //     maxAge: 1
    // },
    VERIFICACION_DOCUMENTAL: {
        id: 'VERIFICACION_DOCUMENTAL',
        name: 'Verificación Documental',
        attachments: undefined,
        midAge: 0.5,
        maxAge: 1
    },
    CONTRATACION_2: {
        id: 'CONTRATACION_2',
        name: 'Generar Contrato',
        attachments:undefined,
        midAge: 0.5,
        maxAge: 1
    },
    SEGURIDAD_SOCIAL: {
        id: 'SEGURIDAD_SOCIAL',
        name: 'Seguridad Social',
        attachments: [
            {
                name: 'Afiliación EPS',
                key: 'EPS',
            },
            {
                name: 'Afiliación Caja de Compensación',
                key: 'CAJA_DE_COMPENSACION',
            },
            {
                name: 'Afiliación Fondo de Pensiones',
                key: 'FONDO_PENSIONES',
            },
            {
                name: 'Afiliación ARL',
                key: 'ARL',
            },
            {
                name: 'Afiliación Cesantías',
                key: 'CESANTIAS',
            },
            {
                name: 'Manual de funciones',
                key: 'MANUAL_FUNCIONES_1',
            },
            {
                name: 'Contrato',
                key: 'CONTRATO',
            },
        ],
        midAge: 2,
        maxAge: 4,
        nextState: 'CONTRATACION_2'
    },
    CONTRATACION_3: {
        id: 'CONTRATACION_3',
        name: 'Validar Contrato',
        midAge: 0.5,
        maxAge: 1
    },
    REPORTE_NOMINA: {
        id: 'REPORTE_NOMINA',
        name: 'Reporte a nomina',
        nextState: 'END',
        restricted:true,
        midAge: 5,
        maxAge: 10
    },
    FINALIZADO: {
        id: 'FINALIZADO',
        name: 'Revisión Final',
        attachments:undefined,
        restricted:true,
        midAge: 7,
        maxAge: 15
    },
    END: {
        id: 'END',
        name: 'Solicitud cerrada',
        attachments:undefined,
        restricted:true,
        midAge: 7,
        maxAge: 15
    }
}

export const tiposDeContrato = [
    { name: 'TH-AP1-F-8 Contrato Fijo rol diario (xa v11)', value: 0 },
    { name: 'TH-AP1-F-9 Contrato Fijo rol mensual (xa v11)', value: 1 },
    { name: 'TH-AP1-F-11 Contrato Obra rol diario (xa V10)', value: 2 },
    { name: 'TH-AP1-F-12 Contrato Obra rol mensual (xa V9)', value: 3 },
    { name: 'TH-AP1-F-13 Contrato indefinido rol mensual (xa V7)', value: 4 },
    { name: 'TH-AP1-F-44 Contrato indefinido rol diario (xa V2)', value: 5 },
    { name: 'TH-AP1-F-X Contrato Fijo medio tiempo Rol Dia (v0)', value: 6 },
    { name: 'TH-AP1-F-X Contrato Fijo medio tiempo Rol Mes (v0)', value: 7 },
    { name: 'TH-AP1-F-17 Contrato aprendizaje (xa V8)', value: 8 }
]